import React, { useRef, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import backgroundImage from "../asset/image/map.png";
import backgroundImage2 from "../asset/image/img3.jpg";
import pageBackground from "../asset/image/img25.png";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import "../pages/pk1.css";

function Pk1() {
  const lowerCardRef = useRef(null);
  const [showMap, setShowMap] = useState(false);
  const navigate = useNavigate();

  const styles = {
    container: {
      width: "100%",
      minHeight: "100vh",
      padding: "150px",
      backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${pageBackground})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundAttachment: "fixed",
    },
    cardContainer: {
      display: "flex",
      flexDirection: "column",
      gap: "300px",
      maxWidth: "1006px",
      margin: "0 auto",
    },
    introCard: {
      width: "100%",
      maxWidth: "1006px",
      height: "584px",
      margin: "0 auto",
      borderRadius: "20px",
      overflow: "hidden",
      position: "relative",
      backgroundImage: `url(${backgroundImage2})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      color: "white",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    },
    contentWrapper: {
      padding: "40px",
      background:
        "linear-gradient(to bottom, rgba(0,0,0,0.4), rgba(0,0,0,0.7))",
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
    },
    title: {
      fontSize: "38px",
      fontWeight: "bold",
      marginBottom: "20px",
      textAlign: "right",
    },
    description: {
      fontSize: "16px",
      lineHeight: "1.6",
      maxWidth: "80%",
      marginBottom: "30px",
      textAlign: "right",
      marginLeft: "auto",
    },
    videoSection: {
      display: "flex",
      justifyContent: "center",
      marginBottom: "20px",
      alignItems: "right",
      marginLeft: "auto",
    },
    videoBtn: {
      backgroundColor: "transparent",
      border: "2px solid white",
      borderRadius: "50%",
      width: "60px",
      height: "60px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      color: "white",
      marginLeft: "auto",
    },
    tripInfo: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-end",
      marginTop: "40px",
    },
    infoDetails: {
      fontSize: "16px",
      display: "flex",
      flexDirection: "column",
      gap: "10px",
      textAlign: "right",
    },
    price: {
      fontSize: "48px",
      fontWeight: "bold",
      marginBottom: "-270px",
      textAlign: "right",
    },
    actionButtons: {
      display: "flex",
      flexDirection: "column",
      gap: "20px",
      marginTop: "30px",
      alignItems: "flex-start",
    },
    roadmapBtn: {
      padding: "16px 32px",
      backgroundColor: "rgba(255, 255, 255, 0.2)",
      border: "1px solid white",
      borderRadius: "8px",
      color: "white",
      cursor: "pointer",
      transition: "all 0.3s ease",
      fontWeight: "500",
      fontSize: "18px",
      minWidth: "200px",
    },
    purchaseBtn: {
      padding: "16px 32px",
      backgroundColor: "white",
      border: "none",
      borderRadius: "8px",
      color: "black",
      cursor: "pointer",
      transition: "all 0.3s ease",
      fontWeight: "500",
      fontSize: "18px",
      minWidth: "200px",
    },
    surfingCard: {
      backgroundImage: `url(${backgroundImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat", // Add this to ensure image repeating is prevented
      borderRadius: "20px",
      padding: "60px",
      maxWidth: "1006px",
      margin: "0 auto",
      color: "white",
      position: "relative",
      overflow: "hidden",
      height: "584px",
    },
    contentOverlay: {
      position: "relative",
      zIndex: 2,
      height: "100%",
      padding: "40px",
    },
    packageTitle: {
      fontSize: "32px",
      fontWeight: "bold",
      textAlign: "right",
      marginBottom: "30px",
    },
    itineraryContainer: {
      maxHeight: "400px",
      overflowY: "auto",
      paddingRight: "20px",
      marginLeft: "50%",
      scrollbarWidth: "thin",
      scrollbarColor: "rgba(255, 255, 255, 0.3) rgba(255, 255, 255, 0.1)",
    },
    daySection: {
      marginBottom: "30px",
    },
    dayTitle: {
      fontSize: "24px",
      marginBottom: "15px",
      color: "#fff",
    },
    dayDescription: {
      fontSize: "16px",
      lineHeight: "1.6",
      marginBottom: "10px",
    },
    locationTag: {
      color: "#ddd",
      fontSize: "14px",
      marginBottom: "5px",
    },
    purchaseButton: {
      position: "absolute",
      bottom: "40px",
      AlignRigh: "40px",
      padding: "16px 32px",
      backgroundColor: "white",
      border: "none",
      borderRadius: "8px",
      color: "black",
      cursor: "pointer",
      transition: "all 0.3s ease",
      fontWeight: "500",
      fontSize: "18px",
    },
    mapOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.8)",
      zIndex: 1000,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    mapContainer: {
      width: "80%",
      height: "80%",
      position: "relative",
      backgroundColor: "white",
      borderRadius: "20px",
      overflow: "hidden",
    },
    closeMap: {
      position: "absolute",
      top: "10px",
      right: "10px",
      backgroundColor: "white",
      border: "none",
      borderRadius: "50%",
      width: "30px",
      height: "30px",
      cursor: "pointer",
      zIndex: 1,
      fontSize: "20px",
    },
    closeButton: {
      position: "absolute",
      top: "20px",
      right: "20px",
      backgroundColor: "transparent",
      border: "none",
      color: "white",
      fontSize: "24px",
      cursor: "pointer",
    },
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    const style = document.createElement("style");
    style.textContent = `
      .itinerary-container::-webkit-scrollbar {
        width: 6px;
      }
      .itinerary-container::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0);
        border-radius: 3px;
      }
      .itinerary-container::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0);
        border-radius: 3px;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const handlePurchaseClick1 = () => {
    navigate("/purchase");
  };

  const handlePurchaseClick = () => {
    if (lowerCardRef.current) {
      lowerCardRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleViewRoadmap = () => {
    setShowMap(true);
  };

  const handleCloseMap = () => {
    setShowMap(false);
  };

  const handleCardClose = () => {
    navigate("/packages");
  };

  return (
    <div style={styles.container} className="container">
      {showMap && (
        <div style={styles.mapOverlay} className="map-overlay">
          <div style={styles.mapContainer} className="map-container">
            <button style={styles.closeMap} onClick={handleCloseMap}>
              ×
            </button>
            <LoadScript googleMapsApiKey="YOUR_GOOGLE_MAPS_API_KEY">
              <GoogleMap
                mapContainerStyle={{ width: "100%", height: "100%" }}
                center={{ lat: 7.957118, lng: 80.7576874 }}
                zoom={15}
              >
                <Marker position={{ lat: 7.957118, lng: 80.7576874 }} />
              </GoogleMap>
            </LoadScript>
          </div>
        </div>
      )}

      <div style={styles.cardContainer} className="card-container">
        <div style={styles.introCard} className="intro-card">
          <div style={styles.contentWrapper} className="content-wrapper">
            <button style={styles.closeButton} onClick={handleCardClose}>
              ×
            </button>
            <h1 style={styles.title} className="title">
              5 Day's Packege{" "}
            </h1>
            <p style={styles.description} className="description">
              Experience the thrill of surfing at Unawatuna, with a tailored
              package that takes you to the best surf spots. Our expert guides
              will ensure you have a safe and exciting adventure!
            </p>

            <div style={styles.videoSection}>
              <button style={styles.videoBtn}>
                <span style={{ fontSize: "24px" }}>▶</span>
              </button>
            </div>

            <div style={styles.tripInfo}>
              <div style={styles.infoDetails}>
                <div>👤 Min 3 Person</div>
                <div>5 Days Trip</div>
                <div style={{ fontSize: "14px", opacity: 0.8 }}>
                  *All the cost calculated and added! including traveling and
                  Hotel costs.
                </div>
              </div>
              <div style={styles.price} className="price">
                75$ Per Person Per Day
              </div>
            </div>

            <div style={styles.actionButtons} className="action-buttons">
              <button
                style={styles.roadmapBtn}
                className="roadmap-btn"
                onClick={handleViewRoadmap}
              >
                VIEW ROADMAP
              </button>
              <button
                style={styles.purchaseBtn}
                className="purchase-btn"
                onClick={handlePurchaseClick}
              >
                Purchase now
              </button>
            </div>
          </div>
        </div>

        <div
          style={{
            ...styles.surfingCard,
            background: `url(${backgroundImage})`,
            backgroundColor: "transparent",
          }}
          className="surfing-card"
          ref={lowerCardRef}
        >
          <div
            style={{
              ...styles.contentOverlay,
              background: "transparent",
            }}
            className="content-overlay"
          >
            <h2 style={styles.packageTitle}>5 Day Packege | 4 nights </h2>
            <div
              style={styles.itineraryContainer}
              className="itinerary-container"
            >
              <div style={styles.daySection}>
                <h3 style={styles.dayTitle}>Day 01 Colombo to Dambulla</h3>
                <p style={styles.dayDescription}>
                  Begin your journey with a visit to the iconic Golden Cave
                  Temple, a UNESCO World Heritage site adorned with ancient
                  murals and Buddha statues. Immerse yourself in local culture
                  with a charming village tour, and end the day with a climb to
                  Sigiriya’s Lion Rock, marveling at its breathtaking views and
                  historical significance.
                </p>
              </div>
              <div style={styles.daySection}>
                <h3 style={styles.dayTitle}>2 Days Kandy</h3>
                <p style={styles.dayDescription}>
                  En route to Kandy, visit a vibrant spice garden and learn
                  about Sri Lanka’s rich history of spices. In Kandy, explore
                  the sacred Dalada Maligawa (Temple of the Tooth Relic), a site
                  of immense spiritual importance. Conclude your day with a
                  stroll through the lush Peradeniya Botanical Gardens,
                  featuring exotic flora and serene landscapes.
                </p>
              </div>
              <div style={styles.daySection}>
                <h3 style={styles.dayTitle}>Day 03 Nuwara Eliya</h3>
                <p style={styles.dayDescription}>
                  Travel to the scenic hill town of Nuwara Eliya, known as
                  "Little England." Enjoy the tranquil Gregory Lake, perfect for
                  boating or a leisurely walk. Visit the Nuwara Eliya Botanical
                  Gardens, rich with vibrant blooms, and the Seeta Amman Temple,
                  a site linked to the Ramayana epic.
                </p>
              </div>

              <div style={styles.daySection}>
                <h3 style={styles.dayTitle}>Day 04 Ella </h3>
                <p style={styles.dayDescription}>
                  Travel to the scenic hill town of Nuwara Eliya, Experience the
                  charm of Ella, starting with a visit to the iconic Nine Arch
                  Bridge. For thrill-seekers, try Skyline Flying for panoramic
                  views. Hike up Little Adam’s Peak for a breathtaking sunrise
                  or sunset, and visit Ravana Ella Waterfall, a spectacular
                  cascade surrounded by legend.
                </p>
              </div>

              <div style={styles.daySection}>
                <h3 style={styles.dayTitle}>Day 05 Yala and Mirissa </h3>
                <p style={styles.dayDescription}>
                  Embark on an adventurous safari at Yala National Park, home to
                  diverse wildlife, including the elusive leopard. Conclude your
                  trip at Mirissa Beach, where you can relax by the turquoise
                  waters or take a whale-watching tour. End your journey with a
                  drop-off at Colombo, completing an unforgettable adventure.
                </p>
              </div>
            </div>
            <button
              style={styles.purchaseButton}
              onClick={handlePurchaseClick1}
              className="bottom-button"
            >
              Purchase now
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Pk1;
